const menuHr = {
    "add_to_cart": "Dodaj u košaricu",
    "add_to_order": "Dodaj u narudžbu",
    "already_in_cart": "Već u vašoj košarici",
    "update_order_item": "Ažuriraj narudžbu",
    "delete_order_item": "Ukloni stavku",
    "available_categories": "Kategorije izbornika",
    "search_menu_placeholder": "Pretraži u izborniku",
    "guides": {
        "scan_qr": "Skenirajte QR kod na stolu telefonom",
        "order": "Naručite odabrane artikle s telefona",
        "pay": "Plaćajte odvojeno ili odjednom s telefona",
        "accept": "Nastaviti"
    },
    "index_image": "Indeksna slika",
    "menu_saved": "Spremljen jelovnik",
    "new_category": "Nova kategorija",
    "menu_editor": "Izbornik uređivača",
    "new_item": "Nova stavka",
    "menu": "Jelovnik ",
    "allergens": "Alergeni",
    "generate_qr": "Generiraj QR kod",
    "allergen_list": {
        "gluten": "Gluten",
        "crustaceans": "Rakovi",
        "eggs": "Jaja",
        "fish": "Riba",
        "peanuts": "Kikiriki",
        "soybeans": "Soja",
        "milk": "Mlijeko",
        "nuts": "Orašasti plodovi",
        "celery": "Celer",
        "mustard": "Senf",
        "sesame": "Sezam",
        "sulphur_dioxide": "sumporov dioksid",
        "lupin": "Lupin",
        "molluscs": "Mekušci",
        "vegan": "Veganski"
    },
    "add_allergen": "Dodaj alergen",
    "auto_translate": "Prijevod jelovnika",
    "no_category_name": "Nije naveden naziv kategorije na trenutnom jeziku",
    "no_item_name": "Nije naveden naziv stavke na trenutnom jeziku",
    "category_and_items_language": "Jezik kategorija i stavki",
    "auto_translate_title": "Automatski prijevod izbornika može se primijeniti samo na kategorije i stavke koje su već spremljene. Preporučuje se unos početnog jezika.",
    "auto_translate_description": "Ova značajka koristi Google prevoditelj. Prijevodi nisu uvijek točni, stoga ih je vrijedno provjeriti.",
    "translate_from": "Prevedi s",
    "translate_to": "Ovim jezicima",
    "auto_translate_error_invalid_languages": "Za prijevod odabrani su nevažeći jezici",
    "auto_translate_success": "Jelovnik je uspješno preveden",
    "auto_translate_error_permission": "Nemate dopuštenje za prevođenje jelovnika",
    "auto_translate_error_generic": "Došlo je do nepoznate pogreške tijekom prevođenja",
    "auto_translate_feature_not_available": "Automatski prijevod izbornika dostupan je samo uz PRO pretplatu.",
    "change_subscription_plan": "Promjena pretplatničkog plana",
    "menu_headers": "Zaglavlja i podnožja izbornika",
    "menu_header_editor_title": "Zaglavlja i podnožja izbornika su tekstovi koji se pojavljuju na vrhu i dnu vašeg online izbornika, a koje možete slobodno odrediti.",
    "menu_header_feature_not_available": "Uređivanje zaglavlja i podnožja izbornika dostupno je samo uz PRO pretplatu.",
    "menu_header": "Zaglavlje izbornika",
    "menu_header_placeholder": "Napišite kratku poruku dobrodošlice ili istaknite trenutnu ponudu",
    "menu_footer": "Podnožje izbornika",
    "menu_footer_placeholder": "Možete unijeti podatke o naknadama za uslugu, alergenima ili drugim važnim informacijama",
    "menu_header_save_success": "Zaglavlje i podnožje izbornika uspješno spremljeno",
    "menu_header_save_error": "Došlo je do pogreške prilikom spremanja zaglavlja i podnožja izbornika",
    "menu_header_permission_error": "Nemate dopuštenje za uređivanje zaglavlja i podnožja izbornika",
    "menu_header_generic_error": "Došlo je do nepoznate pogreške prilikom učitavanja zaglavlja i podnožja izbornika",
    "menu_import": "Uvoz izbornika",
    "import_success": "Posljednji uvoz je uspješno završen",
    "import_failed": "Posljednji uvoz nije uspio zbog izvoza na strani poslužitelja",
    "attached_document": "Priloženi dokument",
    "allowed_file_types": "Dopuštene vrste datoteka: .doc, .docx, .pdf, .txt, .html",
    "import_language_helpertext": "Jezik dokumenta",
    "import_options_pro_helpertext": "Opcije 'Deaktiviraj' i 'Dodaj' dostupne su samo uz PRO pretplatu.",
    "import_option_helpertexts": {
        "replace": "Trenutne kategorije i stavke izbornika bit će izbrisane i zamijenjene novogeneriranim izbornikom.",
        "deactivate": "Trenutne kategorije i stavke izbornika bit će deaktivirane, a novogenerirani izbornik bit će dodan.",
        "add": "Trenutni izbornik će ostati, a nove stavke izbornika bit će dodane nakon trenutnog izbornika."
    },
    "import_type": "Vrsta uvoza",
    "import_options": {
        "replace": "Zamijeniti",
        "deactivate": "Deaktiviraj",
        "add": "Dodati"
    },
    "menu_import_tooltip": "Prenesite datoteku koja sadrži jelovnik vašeg restorana ili navedite poveznicu na web-stranicu koja sadrži jelovnik. U oba slučaja provjerite je li jelovnik tekstualno dostupan u dokumentu jer ne možemo obrađivati slike. Nakon pokretanja uvoza, naša umjetna inteligencija automatski će obraditi datoteku i stvoriti novi jelovnik na odabranom jeziku. Ako kasnije želite prevesti stavke na više jezika, upotrijebite značajku 'Prijevod jelovnika'! Postupak uvoza traje 5 - 10 minuta.",
    "menu_import_replace_warning": "Trenutno odabrana metoda uvoza izbrisat će trenutni izbornik i zamijeniti ga novim izbornikom. Molimo provjerite ima li prenesena datoteka ispravan format i sadržaj jer je operacija nepovratna! Ako ne želite izbrisati trenutni izbornik, odaberite drugu metodu uvoza.",
    "start_import": "Uvoz",
    "file_or_url_required": "Molimo odaberite datoteku ili unesite URL web-stranice",
    "file_and_url_error": "Možete navesti samo datoteku ili URL, ne oboje",
    "import_site_url": "URL web-stranice",
    "import_in_progress": "Uvoz u tijeku",
    "import_duration": "Ovo može potrajati nekoliko minuta",
    "listing_manager_info": {
        "summary": "S Mozrestom možete jednostavno upravljati svojim oglasima i recenzijama s jedne platforme. Uštedite vrijeme, poboljšajte svoju online reputaciju i povećajte operativnu učinkovitost.",
        "bullet_1": "Trenutačno ažurirajte svoje oglase na Tripadvisoru, Apple Maps, Googleu, Facebooku, Quandoou i Bingu samo jednim klikom.",
        "bullet_2": "Primajte obavijesti u stvarnom vremenu kada se vaše radno vrijeme i dostupnost ne podudaraju, čime ćete spriječiti razočaranje gostiju i negativne recenzije.",
        "bullet_3": "Brzo provjerite je li vaš oglas potpunost kako biste bili sigurni da su svi važni detalji - poput fotografija, jelovnika i radnog vremena - točni i ažurni.",
        "setup_button": "Postavite Mozrest",
        "pro_warning": "Za ovu značajku potrebna je PRO pretplata."
    },
    "listing_manager_tabs": {
        "Listing": "Popis",
        "ListingAnalytics": "Analitika popisa",
        "ReviewsPage": "Recenzije",
        "ReviewAnalytics": "Analitika recenzija",
        "ReplyTemplates": "Predlošci odgovora",
        "Notifications": "Obavijesti"
    },
    "review_manager_set_title": "Postavljanje upravitelja recenzija",
    "review_manager_set_description": "Molimo vas da navedete neke podatke o svom poslovanju kako bismo mogli kreirati vaše osnovne postavke",
    "confirm_settings": "Potvrdi postavke"
};

export default menuHr;
